// extracted by mini-css-extract-plugin
export default {"container":"KeyDetails_container__7a9sB","contentContainer":"KeyDetails_contentContainer__bFbm3","leftCol":"KeyDetails_leftCol__j3zlL","rightCol":"KeyDetails_rightCol__43lut"};